import { render, staticRenderFns } from "./Finance.vue?vue&type=template&id=5225902e&scoped=true&"
import script from "./Finance.vue?vue&type=script&lang=js&"
export * from "./Finance.vue?vue&type=script&lang=js&"
import style0 from "./Finance.vue?vue&type=style&index=0&id=5225902e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5225902e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VRow,VTextField})
